import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function BeforeAfter() {
  return <section className="w-full px-4 py-16 max-w-5xl mx-auto" data-id="element-18">
      <motion.h2 initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} className="font-handwriting text-4xl md:text-5xl text-center text-forest font-bold mb-12" data-id="element-19">
        Brunos Verwandlung
      </motion.h2>

      <div className="flex flex-col md:flex-row gap-8" data-id="element-20">
        {/* Before */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="flex-1 bg-red-50/50 p-8 rounded-3xl border border-red-100" data-id="element-21">
          <div className="flex items-center gap-3 mb-6" data-id="element-22">
            <XCircle className="w-8 h-8 text-red-400" data-id="element-23" />
            <h3 className="font-handwriting text-3xl text-red-900 font-bold" data-id="element-24">
              Vorher
            </h3>
          </div>
          <ul className="space-y-4" data-id="element-25">
            {['Ständige Blähungen nach dem Fressen', 'Aufgeblähter, harter Bauch', 'Unruhig und unwohl', 'Peinliche Momente beim Gassi gehen'].map((item, i) => <li key={i} className="flex items-start gap-3 font-serif text-gray-700" data-id="element-26">
                <span className="text-red-400 mt-1" data-id="element-27">•</span>
                <span data-id="element-28">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* After */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="flex-1 bg-forest/5 p-8 rounded-3xl border border-forest/20 relative overflow-hidden" data-id="element-29">
          <div className="absolute -right-4 -top-4 w-24 h-24 bg-forest/10 rounded-full blur-2xl" data-id="element-30"></div>
          <div className="flex items-center gap-3 mb-6 relative z-10" data-id="element-31">
            <CheckCircle2 className="w-8 h-8 text-forest" data-id="element-32" />
            <h3 className="font-handwriting text-3xl text-forest font-bold" data-id="element-33">
              Nachher
            </h3>
          </div>
          <ul className="space-y-4 relative z-10" data-id="element-34">
            {['Keine Blähungen mehr', 'Entspannter, weicher Bauch', 'Ruhig und zufrieden', 'Gemeinsame Abende auf der Couch ❤️'].map((item, i) => <li key={i} className="flex items-start gap-3 font-serif text-gray-800 font-medium" data-id="element-35">
                <CheckCircle2 className="w-5 h-5 text-forest shrink-0 mt-0.5" data-id="element-36" />
                <span data-id="element-37">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}